import { render, staticRenderFns } from "./VPlacementsTableWhiteList.vue?vue&type=template&id=2784aa7e"
import script from "./VPlacementsTableWhiteList.vue?vue&type=script&lang=js"
export * from "./VPlacementsTableWhiteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports